/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.enrichment.platform.admin.rpc.EnrichmentPlatformAdminUsageService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const checkCreditAuthorizationRpc = {
  serviceName: 'com.hubspot.enrichment.platform.admin.rpc.EnrichmentPlatformAdminUsageService',
  rpcName: 'checkCreditAuthorization',
  auth: 'app',
  fingerprint: 'pC6RYX4zhw92uMtA1MmaLJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};